var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pdl-loading',{attrs:{"is-loading":_vm.isMapLoading}},[_c('mapbox-map',{attrs:{"map-classes":_vm.mapClasses,"qaid":"locator-page-map-canvas"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }